import CryptoJS from 'crypto-js'

// 验证码/密码 加密
const keyStr = '-mall4j-password' // 解密用的key
export function encrypt (word) {
  const time = Date.now();

  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const srcs = CryptoJS.enc.Utf8.parse(time + word); // 加密方式: 时间戳 + 密文
  const encrypted = CryptoJS.AES.encrypt(srcs, key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
  return encrypted.toString();
}

// 生成AES密钥
const aesKey = 'iCahZp1gyXyaEywq3srBIw=='
const ivStr = 'iWVjy/0DBFYXcwRneQYMBw=='

// 加密请求参数
export function encryptData (data) {
  // 生成随机的iv（初始化向量）并且编码Base64
  // const iv = CryptoJS.lib.WordArray.random(16);
  // const ivBase64 = iv.toString(CryptoJS.enc.Base64)
  const iv = CryptoJS.enc.Base64.parse(ivStr)
  const key = CryptoJS.enc.Base64.parse(aesKey);
  // 加密明文并转Base64 把iv和data传给后端
  const plainText = typeof data === 'object' ? JSON.stringify(data) : data
  // console.log(plainText, '加密数据', key)
  const ciphertext = CryptoJS.AES.encrypt(
    plainText,
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );
  const encryptedDataBase64 = ciphertext.ciphertext.toString(CryptoJS.enc.Base64)
  // console.log('iv', ivBase64, '编码后data', encryptedDataBase64)
  // return { iv: ivBase64, data: encryptedDataBase64 }
  return encryptedDataBase64
}

//解密响应数据
export function decryptData (data) {
  // console.log(data, 'dddd')
  // key he iv 需要Base64解码
  const key = CryptoJS.enc.Base64.parse(aesKey);
  const iv = CryptoJS.enc.Base64.parse(ivStr);
  // 数据也需要解码
  const ciphertext = CryptoJS.enc.Base64.parse(data);
  // console.log(iv, '解密数据', key)
  const decrypt = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC, // 加密模式
    padding: CryptoJS.pad.Pkcs7 // 填充模式
  });

  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return JSON.parse(decryptedStr)
}